import React from 'react'
import { useTranslation } from 'react-i18next'
import { Select, Radio, WeekdayPicker } from 'components/forms'
import { RadioGroup } from 'informed'
import Divider from 'components/Divider'
import listTags from 'gql/query/listTags'
import { listCashRegisters } from 'gql/query'

const FilterComponent = ({ clearFilter }) => {
	const [t] = useTranslation()

	return(
		<>
			<Divider visible height={20}/>
			<RadioGroup field='isActive'>
				<Radio label={t('media_section.strings.all_media')} />
				<Radio value={true} label={t('media_section.strings.active_media')} />
				<Radio value={false} label={t('media_section.strings.inactive_media')} />
			</RadioGroup>
			<Divider visible height={20}/>
			<Select
				field='tagId'
				valueField='id'
				labelField='name'
				isClearable
				removeOnClear
				remoteOptions={{ query: listTags, variables: { type: 'MediaTag' } }}
				label={t('category_section.fields.group_tag')}
			/>
			{/* <Select field='media' label='Media' placeholder='Wählen Sie aus der Liste'/> media filter by type */}
			<WeekdayPicker
				field='weekDays'
				isClearable
				removeOnClear
				label={t('common.dates.days')}
			/>
			<Select
				field='cashRegisterId'
				valueField='id'
				labelField='name'
				isClearable
				removeOnClear
				remoteOptions={{
					query: listCashRegisters,
					valueField: 'id',
					labelField: 'name',
					variables: { params: { limit: 100 } }
				}}
				isSearchable
				withVirtualBody
				label={t('common.fields.cash_registers')}
			/>
		</>
	)
}

export default FilterComponent

